(() => {
  if (customElements.get('video-actions')) return;

  class VideoActions extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;

      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-play-icon]');
      this.pauseButton = this.querySelector('[data-pause-icon]');

      if (!this.video || !this.playButton || !this.pauseButton) return;

      this.playButton.addEventListener('click', this.play.bind(this));
      this.pauseButton.addEventListener('click', this.pause.bind(this));
      this.video.addEventListener('ended', this.pause.bind(this));
      this.bound = true;
    }

    play() {
      document.querySelectorAll('video-actions video').forEach((video) => {
        if (video !== this.video) video.pause();
      });

      this.video.play();
      this.playButton.classList.add('hide');
    }

    pause() {
      this.video.pause();
      this.playButton.classList.remove('hide');
    }
  }

  customElements.define('video-actions', VideoActions);
})();
